export default __webpack_public_path__ + "static/media/ICSE Physics.6ea12857.pdf";